import {Component, Input, OnInit} from '@angular/core';
import {AppState, ContractType, MortgageContract, MortgageOverview} from '../../state/AppState';
import {ScenarioId} from '../../domain/scenario.model';
import {Store} from '@ngrx/store';
import {removeMortgage, RemoveMortgage, UpdateMortgage, updateMortgage} from '../../state/effects.actions';
import {ListItem} from '../../common/ListItem';
import {toNumber} from '../../util/util';
import {MatDialog} from "@angular/material/dialog";
import {PaymentDialogData, PaymentsDialogComponent} from "../../payments/payments.component";

export interface ScenarioUpdateRequest {
  scenarioId: string;
  contract: MortgageContract;
  mortgageId: string;
}

@Component({
  selector: 'mortgage-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent implements OnInit {
  title = 'mortgage details component';
  _mortgagedAmount: number;
  startYear: number;
  startMonth: number;
  _contractType: string;
  _durationInYears: number;
  interestRate: number;
  _principal: number | null;
  premium: number | null;
  private _mortgage: MortgageOverview;
  public possibleContracts: ListItem[] = [
    {value: 'LINEAR', label: 'Linear'},
    {value: 'ANNUITY_MONTHLY', label: 'Annuity Monthly'},
    {value: 'INTEREST_ONLY', label: 'Interest Only'},
    {value: 'SAVING', label: 'Saving'},
  ];


  @Input() scenarioId: ScenarioId;

  @Input()
  set mortgage(mortgage: MortgageOverview) {
    this._durationInYears = mortgage.contract.durationMonths / 12;
    this.interestRate = mortgage.contract.interestRate;
    this._mortgagedAmount = mortgage.contract.mortgagedAmount;
    this._contractType = mortgage.contract.contractType;
    this._mortgage = mortgage;
    this.premium = mortgage.contract.monthlyPremium;
    const startDate = new Date(mortgage.contract.startDate);
    this.startYear = startDate.getFullYear();
    this.startMonth = startDate.getMonth() + 1;
  }

  toNumber = toNumber

  get paymentsCount() {
    return Object.keys(this._mortgage.payments).length;
  }

  set mortgagedAmount(mortgagedAmount: number) {
    this._mortgagedAmount = mortgagedAmount;
    this._principal = null;
  }

  get mortgagedAmount() {
    return this._mortgagedAmount;
  }

  set contractType(contractType: string) {
    this._contractType = contractType;
    this.calculate();
  }

  get contractType() {
    return this._contractType;
  }

  get principal() {
    return this._principal;
  }

  set durationInYears(durationInYears: number) {
    this._principal = null;
    this._durationInYears = durationInYears;
  }

  get durationInYears() {
    return this._durationInYears;
  }

  constructor(
    private store: Store<AppState>,
    public dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
    console.log('Init mortgage details');
  }

  addPaymentStrategy() {
    this.dialog.open(PaymentsDialogComponent, {
      data: {
        mortgageId: this._mortgage.mortgageId,
        scenarioId: this.scenarioId,
        contractType: this._contractType,
      } as PaymentDialogData,
    });

  }

  isPaymentSupported(): boolean {
    return ContractType[this._contractType] !== ContractType.SAVING;
  }

  submit(event: Event): void {
    event.preventDefault(); // no reload
    this.calculate();
  }

  private calculate(): void {
    const contract: MortgageContract = {
      durationMonths: this._durationInYears * 12,
      mortgagedAmount: this._mortgagedAmount,
      interestRate: this.interestRate,
      contractType: ContractType[this._contractType],
      monthlyPremium: this.premium,
      startDate: new Date(this.startYear, this.startMonth - 1).getTime(),
    };

    this.store.dispatch(updateMortgage({
      contract: contract,
      scenarioId: this.scenarioId,
      mortgageId: this._mortgage.mortgageId
    } as UpdateMortgage));
  }

  remove() {
    this.store.dispatch(removeMortgage({
      scenarioId: this.scenarioId,
      mortgageId: this._mortgage.mortgageId
    } as RemoveMortgage));
  }
}
